export default __webpack_public_path__ + "static/media/loader.873bec8e.gif";